export const mapToEmptyArrayIfNull = (array) => {
  return !array ? [] : array;
};
